module.exports = __webpack_public_path__ + "static/media/shoe-img.65e5de8c.jpg";